<div class="page-loader" [hidden]="!loading">
  <div class="spinner">
    <mat-progress-spinner mode="indeterminate" strokeWidth="4"></mat-progress-spinner>
  </div>
</div>
